<template>
  <v-skeleton-loader
    type="avatar, list-item-two-line,actions"
  ></v-skeleton-loader>
</template>

<script>
export default {
  name: "SkeletonLoader"
};
</script>

<style scoped>
::v-deep .v-skeleton-loader__bone {
  padding-left: 0;
  padding-right: 0;
}

::v-deep .v-skeleton-loader__actions.v-skeleton-loader__bone {
  text-align: left !important;
  padding-top: 0;

  .v-skeleton-loader__button {
    height: 20px;
  }
}
</style>
